import { cn } from "../lib/utils";

const RAG_COLORS = {
  Green: "bg-[#00C781]",
  Amber: "bg-[#FFB300]",
  Red: "bg-[#FF3B30]",
};

export function RagDot({ value, className }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <span className={cn("h-2.5 w-2.5 inline-block", RAG_COLORS[value] || "bg-neutral-300")} />
      <span className="text-xs font-medium">{value || "—"}</span>
    </span>
  );
}

const BADGE_TONES = {
  green: "border-[#00C781] text-[#007a4f] bg-[#00C781]/10",
  amber: "border-[#FFB300] text-[#8a6100] bg-[#FFB300]/10",
  red: "border-[#FF3B30] text-[#b3221a] bg-[#FF3B30]/10",
  blue: "border-[#1E6FE8] text-[#1E6FE8] bg-[#1E6FE8]/5",
  neutral: "border-neutral-400 text-neutral-600 bg-neutral-100",
};

export function toneFor(value) {
  const v = String(value || "").toLowerCase();
  if (["green", "closed", "completed", "complete", "approved", "agreed", "done", "y", "active", "implemented", "resolved", "met", "p", "pass", "signedoff"].includes(v)) return "green";
  if (["amber", "medium", "m", "underassessment", "under assessment", "inprogress", "in progress", "pendingapproval", "mitigating", "submitted", "tobeagreed", "inbuild", "pvt", "uat"].includes(v)) return "amber";
  if (["red", "high", "h", "critical", "open", "blocked", "rejected", "overdue", "n", "f", "fail"].includes(v)) return "red";
  if (["low", "l", "planning", "planned", "draft", "notstarted", "backlog"].includes(v)) return "neutral";
  return "blue";
}

export function StatusBadge({ value, tone }) {
  if (value === undefined || value === null || value === "") return <span className="text-muted-foreground">—</span>;
  return (
    <span className={cn(
      "inline-block border px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide rounded-sm whitespace-nowrap",
      BADGE_TONES[tone || toneFor(value)]
    )}>
      {String(value)}
    </span>
  );
}

export function PageHeader({ overline, title, actions, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        {overline && <div className="overline-label mb-1">{overline}</div>}
        <h1 className="text-2xl sm:text-3xl font-black tracking-tighter font-display leading-none">{title}</h1>
        {children}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function KpiCard({ label, value, sub, testId }) {
  return (
    <div data-testid={testId} className="border border-border bg-card p-4 h-full">
      <div className="overline-label">{label}</div>
      <div className="text-3xl font-black font-display tracking-tighter mt-1">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}
